import { DataTableCol } from "../../../components/tables/types";

export const resumeAccessDataGridCols: DataTableCol[] = [
    {
        title: 'User Batch Name',
        control: 'userBatchName',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'CourseName',
        control: 'courseName',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Actions',
        control: 'both',
        sortable: false,
        isEdit: true,
        isDelete: true,
        canShowColumn: true
    },
];